module.exports = __webpack_public_path__ + "img/noresult@3x.0c26911d.png";